<template>
  <el-table
    ref="singleTable"
    :data="allData"
    :max-height="tableHeight+40"
    stripe
    style="width: 100%"
  >
    <el-table-column type="index" width="100" label="  ">
      <template slot-scope="scope">
        <span>{{ scope.$index + index + 1 }}</span>
      </template>
    </el-table-column>
<!--    @click="clickRow(scope.row)"-->
<!--    style="color: #1137ff; cursor: pointer"-->
    <el-table-column property="name" label="物流园名称" width="300"  align="center">
      <template slot-scope="scope">
        <span

          >{{ scope.row.name }}</span
        >
      </template>
    </el-table-column>
    <el-table-column
      property="longLat"
      label="经纬度"
      align="center"
      width="200"
    ></el-table-column>
    <el-table-column
      property="provname"
      label="省份"
      align="center"
       width="200"
    ></el-table-column>
    <el-table-column
      property="cityname"
      label="城市"
       width="200"
      align="center"
    ></el-table-column>
    <el-table-column
      property="adminname"
      label="区县"
       width="200"
      align="center"
    ></el-table-column>
    <el-table-column property="count" label="全部车辆停靠次数(次)" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.stopCount) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="柴油车辆停靠次数(次)" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.dieStopCount) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="柴油车辆停靠占比" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.dieStopCountRate) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="LNG车辆停靠次数(次)" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.lngStopCount) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="LNG车辆停靠占比" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.lngStopCountRate) }}
      </template>
    </el-table-column>

    <el-table-column property="count" label="电车辆停靠次数(次)" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.eleStopCount) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="电车辆停靠占比" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.eleStopCountRate) }}
      </template>
    </el-table-column>

    <el-table-column property="count" label="氢车辆停靠次数(次)" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.hydStopCount) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="氢车辆停靠占比" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.hydStopCountRate) }}
      </template>
    </el-table-column>

    <el-table-column property="count" label="其他车辆停靠次数(次)" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.otherStopCount) }}
      </template>
    </el-table-column>
    <el-table-column property="count" label="其他车辆停靠占比" width="200" align="center">
      <template slot-scope="scope">
        {{ format(scope.row.otherStopCountRate) }}
      </template>
    </el-table-column>

  </el-table>
</template>
<script>
export default {
  props: {
    allData: {
      type: Array,
      default: () => {
        return []
      },
    },
    index: {
      type: Number,
    },
  },
  methods: {
    clickRow(row) {
      this.$emit('tableShow', row)
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  },
}
</script>
